import SearchBoxCategorySelect from './SearchBoxCategorySelect'
import SearchBoxCitySelect from './SearchBoxCitySelect'
import SearchBoxCountrySelect from './SearchBoxCountrySelect'
import SearchBoxNearYouButton from './SearchBoxNearYouButton'
import SearchBoxRadiusSlider from './SearchBoxRadiusSlider'
import SearchBoxSearchField from './SearchBoxSearchField'
import { useState, useEffect } from 'react'
import { LocationInfoModal } from '../location-info-modal/location-info-modal'
import { useUserLocation } from '~/utils/location/location'

export default function SearchBox() {
	const locationData = useUserLocation()
	const { userLocation, countries, cities } = locationData

	const [showLocationInfoModal, setShowLocationInfoModal] = useState(false)
	const [haveAskedUserCoordinates, setHaveAskedUserCoordinates] =
		useState(false)
	const [sliderValue, setSliderValue] = useState(userLocation?.radius || 50)

	useEffect(() => {
		if (
			!haveAskedUserCoordinates &&
			!userLocation?.havePosition &&
			userLocation?.nearbySelected
		) {
			setHaveAskedUserCoordinates(true)
		}
	}, [haveAskedUserCoordinates, userLocation])

	return (
		<div className="animate-bounce-subtle group relative mx-auto mt-8 mb-8 w-full max-w-3xl md:mb-0">
			<SearchBoxSearchField />
			<div className="mx-auto mt-0.5 flex w-full flex-row items-center justify-between gap-0.5">
				<SearchBoxNearYouButton
					onSuccess={() => setHaveAskedUserCoordinates(true)}
					onError={() => setShowLocationInfoModal(true)}
					setSliderValue={setSliderValue}
				/>
				<div className="hidden md:block">
					<SearchBoxRadiusSlider
						initialValue={sliderValue}
						isVisible={userLocation?.nearbySelected || false}
					/>
				</div>
				<SearchBoxCountrySelect
					countries={countries}
					userLocation={userLocation}
				/>
				<SearchBoxCitySelect cities={cities} userLocation={userLocation} />
				<SearchBoxCategorySelect />
			</div>

			<LocationInfoModal
				open={showLocationInfoModal}
				setOpen={setShowLocationInfoModal}
			/>
		</div>
	)
}
